export default __webpack_public_path__ + "static/media/duster-colour-5.3915ab94.jpg";